import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import ClipboardCopyInput from '../../ClipboardCopyInput';

const ApiInfo = ({apiKey}) => (
    <div>
        <p><FormattedMessage {...messages.surveys.modals.apiKey} /></p>
        <ClipboardCopyInput readOnly value={apiKey} />
    </div>
);

export default ApiInfo;
